<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form" v-loading="loading">
        <el-form ref="form" :model="form" :rules="rules" label-width="1.2rem">
          <el-form-item label="代理商" prop="agentCompanyId" >
            <el-select placeholder="请选择代理商" style="width: 100%;"v-model="form.agentCompanyId">
              <el-option
                v-for="item in agentData"
                :key="item.companyId"
                :label="item.companyName"
                :value="item.companyId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="应用名称" prop="appName">
            <el-input
              style="width: 100%"
              v-model="form.appName"
              clearable
              maxlength="8"
              placeholder="请输入应用名"
            />
          </el-form-item>
          <el-form-item label="回调地址" prop="notifyUrl">
            <el-input
              style="width: 100%"
              v-model="form.notifyUrl"
              type="textarea"
              rows="6"
              clearable
              maxlength="1000"
              show-word-limit
              placeholder="请输入版本描述信息"
            />
          </el-form-item>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>
<script>
import { addInfo, detailInfo, editInfo } from "./api";
import DialogContainer from "@/components/Dialog.vue";
import UploadFiles2 from "@/components/UploadFiles2.vue";
import { validateNumber, validateNumber8 } from "@/utils/validate";
import { getSelectAgent } from "@/views/SystemManagement/AgentManagement/api";
export default {
  name: "AddOrEdit",
  data() {
    return {
      loading: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "40%",
        show: false,
        title: "",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          this.timer = null;
          clearTimeout(this.timer);
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        agentCompanyId: "",
        appName: "",
        notifyUrl: "",
        appId: "",
      },
      rules: {
        agentCompanyId: [{ required: true, message: "代理商不能为空" }],
        appName: [{ required: true, message: "应用名不能为空" }],
      },
      agentData: []
    };
  },
  components: {
    DialogContainer,
  },
  methods: {
    getAgentData() {
      getSelectAgent({
        keyword: ''
      }).then(response => {
        if (response.code === 200) {
          this.agentData = response.data
        }
      })
    },
    getDetail(appId) {
      this.loading = true;
      detailInfo(appId).then((res) => {
        if (res.code === 200) {
          this.form = Object.assign({}, res.data);
        }
      }).finally(()=>{
        this.loading = false
      });
    },
    async init(row) {
     await this.getAgentData()

      if (!!row) {
         this.getDetail(row.appId)
        this.dialogObj.title = "编辑应用";
      } else {
        this.dialogObj.title = "添加应用";
      }
      this.dialogObj.show = true;
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let methodName = "";
          if (this.form.appId) {
            methodName = editInfo;
          } else {
            methodName = addInfo;
          }
          const par = {
            "appId": this.form.appId,
            "agentCompanyId": this.form.agentCompanyId,
            "appName": this.form.appName,
            "notifyUrl":  this.form.notifyUrl,
          };
          methodName(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success(
                  this.form.appId ? "编辑成功" : "保存成功"
                );
                this.$parent.handleAddOrEditSuccess(
                  this.form.appId ? "edit" : "add"
                );
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.config-management {
  width: 100%;
  height: 92vh;
  background-color: #ffffff;
  padding-top: 0.4rem;
  padding-left: 0.4rem;
  box-sizing: border-box;
}
</style>
